// Google Analytics 4. Set GA_MEASUREMENT_ID in src/config.js to switch it on;
// while it is empty nothing is loaded and no requests are made.
//
// In production the gtag snippet is already in the static <head> (written by
// scripts/gen-pages.js), so initAnalytics only has to load it itself when that
// did not happen - e.g. under `npm start`.
import { GA_MEASUREMENT_ID } from "./config";

export const initAnalytics = () => {
    if (!GA_MEASUREMENT_ID) return;
    if (window.gtag) return;

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    // Routes change without a reload, so page_view is sent by hand instead.
    window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
};

const send = (name, params) => {
    if (!GA_MEASUREMENT_ID || !window.gtag) return;
    window.gtag("event", name, params);
};

export const trackPageView = (path) => send("page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
});

// PDF downloads are not sent from here: GA4's enhanced measurement already
// records a file_download event for every click on a link to a .pdf, with
// file_name and link_url. Sending our own as well would count each one twice.

export const trackPreview = (file) => send("pdf_preview", { file_name: file });

export const trackSubscribe = (where) => send("sign_up", { method: where });
